import { h } from 'preact';
import * as BaseComp from 'base/showtimes/showtimesApp.js';
// import s from 'base/showtimes/showtimesApp.sss';

export default class ShowtimesApp extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();

		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize() {
		const windowHeight = window.innerHeight;
		document.documentElement.style.setProperty('--window-height', windowHeight + 'px');
	}
}
